<template>
  <div
    class="c-search"
    v-click-away="closeSearch"
    :class="[{ 'c-search--active': entries }, { 'c-search--home': negative }]"
  >
    <div class="c-search__inputholder">
      <div class="c-search__inputholder__input">
        <iSearch class="search" />
        <input
          class="c-search__input"
          placeholder="Søg..."
          v-model="searchString"
          @keyup.esc="closeSearch"
          @focus="showClear = true"
          ref="searchInput"
        />

        <div v-if="isLoading" class="c-search__load-icon">
          <div
            :class="{
              bouncyBoisMini_blue:
                !negative || entries || employees || datasheets,
            }"
            class="bouncyBoisMini_search bouncyBoisMini"
          >
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <iClose
          class="smallClose"
          v-if="!isLoading && showClear"
          @click="clearInput()"
        />
      </div>
    </div>
    <transition name="fade">
      <div class="c-search__dropdown" v-if="entries || employees || datasheets">
        <div class="c-search__results">
          <div class="employees" v-if="employees">
            <h3
              class="heading"
              v-if="employees.length && (entries.length || datasheets.length)"
            >
              Medarbejdere
            </h3>
            <div
              class="employees__item"
              v-for="employee in this.employees"
              :key="employee.index"
            >
              <div class="c-search__entry wrapper">
                <img :src="employee.image" />
                <div class="content">
                  <div class="content__title">{{ employee.title }}</div>
                  <div class="content__type">{{ employee.job }}</div>
                  <div class="content__info">
                    <a :href="'tel:+45' + employee.phone"
                      >+45 {{ employee.phone }}</a
                    >
                    <a :href="'mailto:' + employee.email">{{
                      employee.email
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="datasheets" v-if="datasheets">
            <h3
              class="heading"
              v-if="datasheets.length && (entries.length || employees.length)"
            >
              Datablade
            </h3>
            <div
              class="datasheets__item"
              v-for="datasheet in this.datasheets"
              :key="datasheet.index"
            >
              <div class="c-search__datasheet wrapper">
                <a
                  class="c-search__datasheet"
                  :href="datasheet.link"
                  target="_blank"
                >
                  <img :src="datasheet.image" />
                  <div class="content">
                    <div class="content__title">{{ datasheet.title }}</div>
                  </div>
                  <p>Download</p>
                  <iBtnArrow />
                </a>
              </div>
            </div>
          </div>
          <div class="entries" v-if="entries">
            <h3
              class="heading"
              v-if="entries.length && (employees.length || datasheets.length)"
            >
              Indhold
            </h3>
            <h3 class="heading" v-else-if="entries.length && employees.length">
              Indhold
            </h3>
            <h3 class="heading" v-else-if="entries.length && datasheets.length">
              Indhold
            </h3>
            <div
              class="entries__item"
              v-for="entry in this.entries"
              :key="entry.index"
            >
              <a :href="entry.link" class="c-search__entry">
                <img :src="entry.image" />
                <div class="content">
                  <div class="content__title">{{ entry.title }}</div>
                  <div class="content__type">{{ entry.type }}</div>
                </div>
                <iBtnArrow />
              </a>
            </div>
            <div
              class="entries--empty"
              v-if="!entries.length && !employees.length && !datasheets.length"
            >
              Ingen resultater
            </div>
          </div>
        </div>
        <div class="c-search__logo">
          <iLogo />
        </div>
        <div class="c-search__close" @click="closeSearch">
          <iClose />
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="c-search__bg"
        v-if="entries || employees"
        @click="closeSearch"
      ></div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mixin as VueClickAway } from 'vue3-click-away';
import { debounce } from '@/vue/utils/helpers';

import iClose from '@web/assets/icon/plus.svg';
import iSearch from '@web/assets/icon/search.svg';
import iBtnArrow from '@web/assets/icon/btnArrow.svg';
import iLogo from '@web/assets/logo/logo.svg';

export default {
  name: 'Search',
  mixins: [VueClickAway],
  components: {
    iClose,
    iSearch,
    iBtnArrow,
    iLogo,
  },
  props: {
    negative: Boolean,
  },
  data() {
    return {
      searchString: '',
      entries: null,
      employees: null,
      datasheets: null,
      isLoading: false,
      showClear: false,
      searching: false,
    };
  },
  watch: {
    searchString(string) {
      this.inputChanged(string, this);
      if (string) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },
    searching(value) {
      if (!value) {
        document.getElementsByTagName('html')[0].classList.remove('lockscroll');
      } else {
        document.getElementsByTagName('html')[0].classList.add('lockscroll');
      }
    },
  },
  methods: {
    clearInput() {
      this.searchString = '';
    },
    inputChanged: debounce((string, vm) => {
      vm.searchFor = string;
      vm.getResults();
    }, 500),

    getResults() {
      if (this.searchFor.length > 2) {
        this.isLoading = true;

        axios
          .get(
            '/api/qd/search/' + this.searchFor.replace(' ', '%20') + '?limit=5'
          )
          .then((response) => {
            this.entries = response.data.entries;
            this.employees = response.data.employees;
            this.datasheets = response.data.datasheets;
            this.isLoading = false;
            this.searching = true;
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    closeSearch() {
      this.searchString = '';
      this.entries = null;
      this.employees = null;
      this.datasheets = null;
      this.show = false;
      this.showClear = false;
      this.searching = false;
      if (this.$refs.searchInput) {
        this.$refs.searchInput.blur();
      }
    },
  },
};
</script>

<style lang="scss">
// @import "@backend/scss/abstracts/variables.scss";
@import '@backend/scss/app.scss';

.c-search {
  $root: &;
  z-index: 2;

  &__inputholder {
    transition: $t-hover;
    background-color: #f5f5f5;
    padding: 10px;
    box-sizing: border-box;
    height: 50px;
    border-radius: 50px;
    z-index: 6;
    position: relative;
    border: 1px solid #f5f5f5;

    &:hover {
      transition: $t-hover;
      border: 1px solid rgba($color: $c-darkblue, $alpha: 0.3);
    }

    &__input {
      display: flex;
      align-items: center;
      height: 100%;

      input {
        border: none;
        flex-grow: 1;
        height: 100%;
        margin-left: 5px;
        background-color: rgba($color: #000000, $alpha: 0);
        margin-right: 10px;
        color: $c-darkblue;
      }
      .search {
        height: 30px;
        width: 30px;
        path {
          fill: $c-darkblue;
        }
      }
      .smallClose {
        width: 10px;
        margin-right: 10px;
        transform: rotate(45deg);
        path {
          fill: $c-darkblue;
        }
      }
    }
  }

  &--home {
    .c-search__inputholder {
      transition: $t-hover;
      background-color: rgba($color: #f5f5f5, $alpha: 0.2);
      padding: 10px;
      box-sizing: border-box;
      height: 50px;
      border-radius: 50px;
      z-index: 6;
      position: relative;

      border: 1px solid transparent;

      &:hover {
        transition: $t-hover;
        border: 1px solid rgba($color: $c-white, $alpha: 0.3);
      }

      &__input {
        display: flex;
        align-items: center;
        height: 100%;

        input {
          border: none;
          flex-grow: 1;
          height: 100%;
          margin-left: 5px;
          background-color: rgba($color: #000000, $alpha: 0);
          margin-right: 10px;
          color: $c-white;
          &::placeholder {
            color: $c-white;
            opacity: 0.6;
          }
        }
        .search {
          height: 30px;
          width: 30px;
          path {
            fill: $c-white;
          }
        }
        .smallClose {
          width: 10px;
          margin-right: 10px;
          transform: rotate(45deg);
          path {
            fill: $c-white;
          }
        }
      }
    }
  }

  &--active {
    .c-search__inputholder {
      background-color: #f5f5f5;
      padding: 10px;
      box-sizing: border-box;
      height: 50px;
      border-radius: 50px;
      z-index: 6;
      position: relative;

      &__input {
        display: flex;
        align-items: center;
        height: 100%;

        input {
          border: none;
          flex-grow: 1;
          height: 100%;
          margin-left: 5px;
          background-color: rgba($color: #000000, $alpha: 0);
          margin-right: 10px;
          color: $c-darkblue;

          &::placeholder {
            color: $c-dark;
            opacity: 0.6;
          }
        }
        .search {
          height: 30px;
          width: 30px;
          path {
            fill: $c-darkblue;
          }
        }
        .smallClose {
          width: 10px;
          margin-right: 10px;
          transform: rotate(45deg);
          cursor: pointer;
          path {
            fill: $c-darkblue;
          }
        }
      }
    }
  }

  &__datasheet {
    svg {
      transform: rotate(90deg);
    }
    p {
      font-size: 15px;
      margin-right: 10px;
    }
  }

  &__dropdown {
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    right: 0;
    padding-top: 115px;
    width: 100%;
    background: $c-white;
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.5);
  }

  &__bg {
    z-index: 4;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: $c-overlay;
  }
  &__close {
    position: absolute;
    top: 33.5px;
    right: 30px;

    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 50px;
    // background: $c-light;
    border-radius: 10px;
    transition: all $t-hover;

    svg {
      transform: rotate(45deg);
      width: 25px;
      height: 25px;
      path {
        transition: $t-hover;
        fill: darken($color: $c-light, $amount: 30);
      }
    }

    &:hover {
      cursor: pointer;
      // background: darken($c-light, 10);
      svg {
        path {
          transition: $t-hover;
          fill: $c-red;
        }
      }
    }
  }

  &__logo {
    position: absolute;
    top: 33.5px;
    height: 50px;
    display: flex;
    align-items: center;
    left: $grid-keep;
    svg {
      width: 213px;
      .fill {
        fill: $c-darkblue;
      }
    }
  }

  &__load-icon {
    height: 80px;
  }

  &__results {
    //   @include grid-container();
    width: 44%;
    margin: 0 auto;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 30px;
    max-height: calc(100vh - 115px);
    overflow-y: auto;

    .heading {
      margin-bottom: 10px;
      color: $c-darkblue;
      // text-align: center;
    }
    .employees {
      margin-bottom: 30px;
      &__item {
        &:first-child {
          border-top: 1px solid $c-light;
        }
        &:last-child {
          border-bottom: none;
        }
        border-bottom: 1px solid $c-light;

        .wrapper {
          display: flex;
          padding: 10px;
          padding-left: 10px;
          padding-right: 10px;

          img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 10px;
          }

          .content {
            margin-left: 20px;
            flex-grow: 1;
            padding-right: 20px;
            &__title {
              font-size: 13px;
              line-height: 16px;
              letter-spacing: -0.13px;
              font-weight: $f-bold;
              color: $c-darkblue;
              margin-bottom: 2px;
            }

            &__type {
              font-weight: $f-medium;
              font-size: 11px;
              letter-spacing: -0.11px;
              line-height: 11px;
              opacity: 0.5;
              color: $c-darkblue;
              transition: all $t-hover;
            }

            &__info {
              margin-top: 5px;

              a {
                line-height: 13px;
                font-size: 13px;
                letter-spacing: -0.15px;
                font-weight: $f-regular;

                &:first-child {
                  margin-right: 15px;
                }
              }
            }
          }
        }
      }
    }
    .datasheets,
    .entries {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      // flex-wrap: wrap;

      &__item {
        // @include grid-col($width: 4, $gutter: 10px);
        // margin-bottom: 10px;
        &:first-child {
          border-top: 1px solid $c-light;
        }
        &:last-child {
          border-bottom: none;
        }
        border-bottom: 1px solid $c-light;

        a {
          display: flex;
          padding: 10px;
          padding-left: 10px;
          padding-right: 10px;
          // border-right: 1px solid $c-seperator;
          transition: all $t-hover;
          // background-color: $c-light;
          border-radius: 10px;
          align-items: center;

          img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: 10px;
          }
          .content {
            margin-left: 20px;
            flex-grow: 1;
            padding-right: 20px;
            &__title {
              font-size: 13px;
              line-height: 16px;
              letter-spacing: -0.13px;
              font-weight: $f-bold;
              color: $c-darkblue;
              transition: all $t-hover;
              text-transform: uppercase;
            }

            &__type {
              font-weight: $f-medium;
              font-size: 11px;
              letter-spacing: -0.11px;
              line-height: 14px;
              opacity: 0.5;
              color: $c-darkblue;
              transition: all $t-hover;
            }
          }
          svg {
            margin-left: 5px;
            width: 16px;
            transition: all 0.3s cubic-bezier(0.46, 0.04, 0.13, 0.59);
            .fill {
              fill: $c-darkblue;
            }
          }

          &:hover {
            background-color: #fafafa;
            div {
              .title {
                color: $c-red;
              }
              .type {
                color: $c-red;
              }
            }
            svg {
              margin-right: 5px;
              margin-left: 0;
              transition: all 0.3s cubic-bezier(0.46, 0.04, 0.13, 0.59);
              .fill {
                fill: $c-red;
              }
              .hover {
                transition: all 0.3s cubic-bezier(0.46, 0.04, 0.13, 0.59);
                fill: none;
              }
            }
            cursor: pointer;
          }
        }
      }

      &--empty {
        font-size: 13px;
        padding: 30px 10px;
        width: 100%;
        text-align: center;
      }
    }
  }
}

@media all and (max-width: 1280px) {
  .c-search {
    &__logo {
      left: 30px;
    }
  }
}
</style>
